import { HANDLE_ERRORS, HANDLE_SUCCESS } from "./types";

export const handleErrors = ({ message, open }) => ({
  type: HANDLE_ERRORS,
  payload: { message, open }
});

export const handleSuccess = ({ message, open }) => ({
  type: HANDLE_SUCCESS,
  payload: { message, open }
});



// WEBPACK FOOTER //
// ./src/actions/handleErrors.js